import { v7 as uuidv7 } from 'uuid';
import EdudoResponse from '../models/edudo-response';
import HttpService from './http-service';

// The client picks each message's id, so a retry of the same send can reuse it and never write twice.
export const newMessageId = (): string => uuidv7();

export default class ConversationService {
  private schoolUuid: string;

  constructor(schoolUuid: string) {
    this.schoolUuid = schoolUuid;
  }

  private basePath(): string {
    return `/v1/schools/${this.schoolUuid}/conversations`;
  }

  private backofficeBasePath(): string {
    return `/school-backoffice-bff/v1/schools/${this.schoolUuid}/conversations`;
  }

  async listConversations(): Promise<ConversationListItem[]> {
    const response = await HttpService.getJson<EdudoResponse<ConversationListItem[]>>(this.backofficeBasePath());

    return response.data;
  }

  // Opening records no read, for anyone: a participant moves their own position with markRead.
  async getConversation(conversationId: string, query: ConversationQuery = {}): Promise<ConversationScreen> {
    const params = new URLSearchParams();
    if (query.before) params.set('before', query.before);
    if (query.since) params.set('since', query.since);
    const search = params.toString();

    const response = await HttpService.getJson<EdudoResponse<ConversationScreen>>(
      `${this.backofficeBasePath()}/${conversationId}${search ? `?${search}` : ''}`
    );

    return response.data;
  }

  // Answers the module's message, not the BFF's: the screen picks the sent message up on its next poll.
  async sendMessage(conversationId: string, messageId: string, text: string): Promise<void> {
    await HttpService.postJson(`${this.basePath()}/${conversationId}/messages`, { id: messageId, text });
  }

  // Only moves forward.
  async markRead(conversationId: string, upToMessageId: string): Promise<void> {
    await HttpService.putJson(`${this.basePath()}/${conversationId}/read-position`, { upToMessageId });
  }

  async leave(conversationId: string): Promise<void> {
    await HttpService.delete(`${this.basePath()}/${conversationId}/participants/me`);
  }
}
